import React from 'react';
import proptypes from 'prop-types';
import { Quotes } from '@thd-olt-component-react/quotes';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

const { string } = proptypes;

export const QuotesCard = ({ componentId = '' }) => (
  <ErrorBoundary name="dashboard-snapshot-quotes">
    <Quotes componentId={componentId} isDashboardSnapshot fillHeight />
  </ErrorBoundary>
);

QuotesCard.propTypes = {
  componentId: string,
};

QuotesCard.displayName = 'QuotesCard';
QuotesCard.dataModel = Quotes.dataModel;
